export default __webpack_public_path__ + "static/media/Messages.374dc543.svg";